module.exports = __webpack_public_path__ + "img/todo.fa9fa4a5.jpg";